import { type FulfillmentApi } from '@entities/fulfillment'

/**
 * Фотографии идут не через общий прокси, а через собственные маршруты приложения:
 * прокси умеет только JSON, а тут нужны файлы и метод DELETE.
 */
const readPhotos = async (response: Response): Promise<FulfillmentApi.Photo[]> => {
  if (!response.ok) {
    throw new Error('photo request failed')
  }
  const body = (await response.json()) as { data?: FulfillmentApi.PhotoListData }

  return body.data?.photos ?? []
}

export const uploadFulfillmentPhotos = async (id: string, files: File[]) => {
  const body = new FormData()
  for (const file of files) {
    body.append('photos', file)
  }

  return readPhotos(await fetch(`/api/fulfillment/${id}/photos`, { method: 'POST', body }))
}

export const deleteFulfillmentPhoto = async (id: string, photoId: string) =>
  readPhotos(await fetch(`/api/fulfillment/${id}/photos/${photoId}`, { method: 'DELETE' }))
